
<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="buscar">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <span>Nome</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formFiltro.nomeTabela"
            :state="validateState('Nome')"
            :danger="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>

        <div class="vx-col sm:w-1/4 w-full">
          <span>Grupo</span>
          <v-select
            :options="grupos"
            name="Grupos"
            id="Grupos"
            v-model="formFiltro.idGrupo"
            :state="validateState('Grupo')"
            :class="validateClass('Grupo')"
          ></v-select>
        </div>

        <div class="vx-col sm:w-1/4 w-full">
          <span>Estado</span>
          <v-select
            :options="estados"
            name="Estado"
            id="Estado"
            v-model="estado"
            @selected="buscaDadosSelectsCidades"
            :state="validateState('Estado')"
            :class="validateClass('Estado')"
          ></v-select>
        </div>

        <div class="vx-col sm:w-1/4 w-full">
          <span>Cidade</span>
          <v-select
            :options="cidades"
            name="Cidade"
            id="Cidade"
            v-model="formFiltro.cidade"
            :state="validateState('Cidade')"
            :class="validateClass('Cidade')"
          ></v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mr-3 mb-2">Buscar</vs-button>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import locale from "./../../locale";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import swal from "sweetalert";
import vSelect from "vue-select";
import cpfCnpj from "../../services/cpfCnpj";
import service from "../../services";
import BotaoSubmit from "../../components/BotaoSubmit";

export default {
  props: {
    sideBar: {
      type: Boolean
    },
    dados: {
      type: Object
    }
  },
  watch: {
    estado(newValue, oldValue) {
      console.log(newValue);
      if (newValue) {
        this.formFiltro.estado = newValue;
        this.formFiltro.cidade = null;
        this.buscaDadosSelectsCidades(
          "domMunicipio",
          "cidades",
          "nomeCidade",
          "idCidade"
        );
      } else {
        this.cidades = [];
      }
    }
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      cidades: [],
      grupos: [],
      languages: lang,
      estado: null,
      funcoesValicao: null,
      formFiltro: {
        idEmpresa: null,
        idGrupo: null,
        nomeTabela: "",
        cidade: "",
        estado: ""
      }
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then(res => {
        res.data.forEach(element => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao]
          });
        });
      });
    },
    buscaDadosGrupos() {
      service
        .getAll("Grupo", {}, "list/idEmpresa=" + this.idEmpresa)
        .then(res => {
          res.data.forEach(element => {
            this.grupos.push({
              id: element.idGrupo,
              label: element.nomeGrupo
            });
          });
        });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll("g", {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then(res => {
          res.data.forEach(element => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao]
            });
          });

          this.$vs.loading.close();
        });
    },
    buscar() {
      this.$emit("filtro", this.formFiltro);
    }
  },
  mounted() {
    this.buscaDadosGrupos();
    this.buscaDadosSelects("domUf", "estados", "nomeUf", "codUf");
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect
  }
};
</script>
<!------------ END SCRIPT ------------>
